import { Editor } from '@tiptap/react';
import { XIcon } from 'lucide-react';
import React from 'react';

import { Button } from '../ui/button';
import { Separator } from '../ui/separator';

import { CommentEditor } from './comment-editor';
import { MarkdownEditor } from './markdown-editor';

import type { GithubCollaborator } from '@/services/repo';

interface DiscussionCommentEditorProps {
  comment: string;
  onCommentChange: (comment: string) => void;
  replyQuote: string | undefined;
  clearReplyQuote: () => void;
  onBlur?: () => void;
  onFocus?: () => void;
  onSubmit: () => void;
  mentionCollaborators?: GithubCollaborator[];
  owner: string;
}

export const DiscussionCommentEditor = React.forwardRef<Editor, DiscussionCommentEditorProps>(
  (
    { comment, onCommentChange, replyQuote, clearReplyQuote, onBlur, onFocus, onSubmit, mentionCollaborators, owner },
    ref
  ) => {
    return (
      <div className="flex flex-col flex-1 gap-0 pb-2 px-2">
        {replyQuote && (
          <>
            <Separator className="w-full" />
            <div className="relative rounded bg-gray-50 px-1">
              <MarkdownEditor value={replyQuote} editable={false} placeholder="Write a comment..." owner={owner} />
              <Button variant="ghost" size="sm" onClick={clearReplyQuote} className="absolute top-1 right-1 p-0">
                <XIcon className="size-3" />
              </Button>
            </div>
          </>
        )}
        <CommentEditor
          ref={ref}
          value={comment}
          onChange={onCommentChange}
          onSubmit={onSubmit}
          onFocus={onFocus}
          onBlur={onBlur}
          placeholder={replyQuote ? 'Write a reply...' : 'Add a discussion comment...'}
          className="w-full"
          isExpanded={true}
          editable={true}
          mentionCollaborators={mentionCollaborators}
          owner={owner}
        />
      </div>
    );
  }
);
